import React from 'react';
import DivisionsTab from '../../components/Panels/DivisionsTab';



const Teams = () => (
    <DivisionsTab />
);

export default Teams;


// WEBPACK FOOTER //
// ./src/pages/Teams/index.js